<template>
  <div>
    <div class="listWrapper" v-if="!isEditing">
      <el-row type="flex" justify="space-between">
        <el-col :xs="12" :sm="10" :md="10" :lg="10" :xl="10">
          <el-input
            :placeholder="$t('pesquisar')"
            prefix-icon="el-icon-search"
            v-model="filter"
          ></el-input>
        </el-col>
        <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">
          <el-button
            class="right"
            type="primary"
            icon="el-icon-plus"
            @click="add()"
            >{{ $t('adicionar') }}</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="
          tableData.filter(
            (data) =>
              !filter ||
              data.description.toLowerCase().includes(filter.toLowerCase())
          )
        "
        stripe
        style="width: 100%"
        :default-sort="{ prop: 'description', order: 'ascending' }"
      >
        <el-table-column
          sortable
          prop="description"
          :label="$t('descricao')"
        ></el-table-column>

        <el-table-column
          prop="function"
          :label="$t('funcao')"
        ></el-table-column>

        <el-table-column width="180">
          <template slot-scope="scope">
            <el-button
              type="info"
              icon="el-icon-edit"
              @click="editar(scope.row.id)"
              circle
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="remove(scope.row.id, scope.row.name)"
              circle
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="editWrapper" v-if="isEditing">
      <el-form
        :model="ruleForm"
        :rules="!id ? rules : {}"
        ref="ruleForm"
        label-position="top"
      >
        <el-row
          :gutter="5"
          type="flex"
          justify="start"
          style="margin-top: -30px"
        >
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('descricao')" prop="description">
              <el-input
                ref="description"
                placeholder="Descrição da Ação"
                v-model="ruleForm.description"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('funcao')" prop="function">
              <el-select
                v-model="ruleForm.function"
                ref="function"
                clearable
                placeholder="Definir Função"
                @clear="ruleForm.function = ''"

              >
                <el-option
                  v-for="item in DriverFunctions"
                  :key="item.id"
                  :label="item.description"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> </el-row
        ><br /><br />

        <el-form-item style="text-align: center">
          <el-button
            type="warning"
            v-if="isAdding"
            autofocus
            @click="submitForm('ruleForm')"
            >{{ $t('adicionar') }}</el-button
          >
          <el-button
            type="warning"
            v-if="!isAdding"
            autofocus
            @click="editForm('ruleForm')"
            >{{ $t('atualizar') }}</el-button
          >
          <el-button @click="back()">{{ $t('voltar') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { DriverActionService } from '@/services/umov/driver-action.services';
import { i18n } from '@/plugin/i18n';

export default {
  name: 'DriverActions',

  data() {
    return {
      filter: '',
      id: '',
      tableData: [],
      isAdding: false,
      isEditing: false,
      DriverFunctions: [
        {
          id: 0,
          description: 'Nenhum',
        },
        {
          id: 1,
          description: 'Tirar Foto',
        },
        {
          id: 2,
          description: 'Bipar',
        },
        {
          id: 3,
          description: 'Encerrar rota',
        },
      ],
      rules: {
        description: [
          {
            required: true,
            message: i18n.tc('descricao-obrigatorio'),
            trigger: 'blur',
          },
        ],
      },

      ruleForm: {
        description: '',
        function: '',
      },
    };
  },

  methods: {

    fetchRecords() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc('carregando'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });

      DriverActionService.list()
        .then(({ records }) => {
          records.forEach((item) => {
            switch (item.function) {
              case '1':
                item.function = 'Tira Foto';
                break;

              case '2':
                item.function = 'Enviar Informação';
                break;

              default:
                item.function = '';
                break;
            }
          });

          vm.tableData = records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc('erro'),
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    add() {
      this.isAdding = true;
      this.isEditing = true;
    },

    back() {
      this.isEditing = false;
      this.isAdding = false;
      this.id = undefined;
      this.resetForm('ruleForm');
    },

    editar: function(id) {
      const vm = this;
      vm.isEditing = true;
      vm.id = id;
      vm.get();
    },

    remove: function(id, name) {
      const vm = this;
      this.$confirm(
        i18n.t('confirmar-eliminacao-acao', { role: name }),
        i18n.tc('aviso'),
        {
          confirmButtonText: 'OK',
          cancelButtonText: i18n.tc('cancelar'),
          type: i18n.tc('aviso'),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading({
          lock: true,
          text: i18n.tc('carregando'),
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });

        DriverActionService.delete(id)
          .then((response) => {
            setTimeout(() => {
              const index = vm.tableData.findIndex((dt) => dt.id == id);
              vm.tableData.splice(index, 1);
            }, 300);
            this.$message({
              type: 'success',
              message: i18n.tc('acao-eliminado-sucesso'),
            });
          })
          .catch((error) => {
            vm.$notify.error({
              title: i18n.tc('erro'),
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },

    get() {
      const vm = this;

      DriverActionService.get(vm.id)
        .then((item) => {
          vm.ruleForm.description = item.description;
          vm.ruleForm.function = item.function;
        })
        .catch((error) => {
          vm.$message({
            type: 'error',
            message: error,
          });
        });
    },

    submitForm(formName) {
      const vm = this;

      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const formData = {
            description: vm.ruleForm.description,
            function: vm.ruleForm.function,
          };

          DriverActionService.add(formData)
            .then((response) => {
              this.$message({
                type: 'success',
                message: i18n.tc('acao-adicionado-sucesso'),
              });

              vm.tableData.push(response);
              vm.$refs[formName].resetFields();
              vm.fetchRecords();
              setTimeout(() => {
                vm.back();
              }, 1000);
            })
            .catch((error) => {
              this.$message({
                type: 'error',
                message: error,
              });
            });
        } else {
          return false;
        }
      });
    },

    editForm(formName) {
      const vm = this;

      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc('carregando'),
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          });

          DriverActionService.update(vm.id, vm.ruleForm)
            .then((response) => {
              this.$message({
                type: 'success',
                message: i18n.tc('acao-atualizado-sucesso'),
              });

              vm.fetchRecords();
              setTimeout(() => {
                vm.back();
              }, 1000);
            })
            .catch((error) => {
              this.$message({
                type: 'error',
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },

  mounted() {
    const vm = this;
    if (!vm.id) {
      vm.fetchRecords();
    }
  },
};
</script>
<style>
.right {
  float: right;
}
</style>
